import { Component } from "react";
import { CircularProgress } from "@material-ui/core";

export default class BetterCircularProgress extends Component {
    render() {
        return (
            <div className={`${this.props.className ?? ''}`} style={{ width: "100%" }}>
                {this.props.loading ? (
                    <div style={{ textAlign: "center" }} >
                        <div style={{ marginTop: "25vh", marginBottom: "25vh" }}>
                            <CircularProgress color="inherit" size={50} />
                        </div>
                    </div>
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
